import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
} from "@mui/material";
import { getTypeName } from "src/utils/transactionUtils";
import UserLevelChip from "../level/UserLevelChip";
import CoinIcon from "../icons/CoinIcon";
import { fCoins } from "src/utils/formatNumber";
import { fDateTime } from "src/utils/formatTime";

export default function CoinTransactionsTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>User</TableCell>
            <TableCell>User Value</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Pair</TableCell>
            <TableCell>Reference</TableCell>
            <TableCell>Timestamp</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.transactions?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
              ref={
                index === props.transactions.length - 1
                  ? props.lastTransactionRef
                  : null
              }
            >
              <TableCell component="th" scope="row">
                {row.transactionId}
              </TableCell>
              <TableCell component="th" scope="row">
                <a
                  href={`/dashboard/profile?user_id=${row.userId}`}
                  style={{ marginLeft: 8 }}
                >
                  {row.userId}
                </a>
              </TableCell>
              <TableCell component="th" scope="row">
                <UserLevelChip level={row.userLevelStats?.topPct} />
              </TableCell>
              <TableCell component="th" scope="row">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <CoinIcon />
                  {fCoins(row.amount)}
                </div>
              </TableCell>
              <TableCell component="th" scope="row">
                {getTypeName(row.transactionType, row.reference)}
              </TableCell>
              <TableCell component="th" scope="row">
                <a
                  href={`/dashboard/coin-transaction?transaction_id=${row.pairTransactionId}`}
                >
                  {row.pairTransactionId}
                </a>
              </TableCell>
              <TableCell component="th" scope="row">
                {row.reference}
              </TableCell>
              <TableCell component="th" scope="row">
                {fDateTime(new Date(row?.createdAt * 1000 || ""))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
